const Parser = require('./Parser');
const FirstLineValidation = require('./FirstLineValidation');
const { spreadsheetType } = require('@transfeeradev/api-enums');
const { errors } = require('@transfeeradev/api-enums');
const transferPixWithKeyHeaders = require('./header/transferPixWithKeyHeaders');
const transferHeaders = require('./header/transferHeaders');
const billetHeaders = require('./header/billetHeaders');

class Type {
  constructor(data) {
    this._data = data;
    this._parser = new Parser(data);
    this._firstLineValidation = new FirstLineValidation(data);
  }

  get() {
    const firstLineValidationResult = this._firstLineValidation.validate();

    if (firstLineValidationResult) {
      return firstLineValidationResult.error;
    }

    const headers = this._parser.getHeadersFormatted();

    if (headers.toString().includes(billetHeaders.barcode.description)) {
      return spreadsheetType.BILLET;
    }

    if (headers.toString().includes(transferPixWithKeyHeaders.pixKey.description)) {
      return spreadsheetType.TRANSFER_WITH_PIX_KEY;
    }

    if (headers.toString().includes(transferHeaders.value.description)) {
      return spreadsheetType.TRANSFER;
    }

    return errors.ptBr.she.FORMAT_ERROR;
  }
}

module.exports = Type;
